// HOW TO USE
// routeCheck use in router: if (!router.app.$services.routeCheck(to)) { next('/notAllowed') } else { next() }
// has use in js function
// de use in .vue (page) file: <div v-services="['PER_ELeave_BE']">

import { parseJwt } from './utils'
import { getStorage } from './storageUtil'

export default {
  install (Vue) {
    Vue.prototype.$perServices = {
      _userServices: null,
      _getServices: function () { // return array
        if (!this._userServices) {
          // should be replace, demo only
          // get service from Jwt
          this._userServices = parseJwt(getStorage('g2e-jwt-token')).per_services
        }
        return this._userServices
      },
      hasServices: function (reqServices) {
        if (reqServices && !reqServices.length) { // Don't need service
          return true
        } else { // Check if the user has one of Services
          let userServices = this._getServices()
          return reqServices.some(reqService => {
            return userServices.includes(reqService)
          })
        }
      },
      routeCheck: function (to) { // return true, if it has the service or the page don't need service
        // check if user has the service
        let reqServices = []
        to.matched.forEach(record => {
          if (record.meta.perServices) {
            reqServices = reqServices.concat(record.meta.perServices)
          }
        })
        return this.hasServices(reqServices)
      },
      debug: function () {
        console.log(this._getServices())
      }
    }

    Vue.directive('perServices', {
      inserted: function (el, binding, vnode) {
        // el.style.position = 'fixed'
        // el.style.top = binding.value + 'px'
        if (Vue.prototype.$perServices.hasServices && !Vue.prototype.$perServices.hasServices(binding.value)) {
          el.parentNode.removeChild(el)
        }
      }
    })
  }
}
